import { Pipe, PipeTransform } from '@angular/core';
import {Observable, of} from 'rxjs';
import {BlocksHelper} from '../../helper/blocks.helper';

@Pipe({
    name: 'tClassBlockColor',
    standalone: false
})
export class TClassBlockColorPipe implements PipeTransform {

  constructor(private blocksHelper: BlocksHelper) {
  }

  transform(value: string): Observable<string> {
    const result = this.blocksHelper.blockColors.filter((b) => b.class === value.split('.')[0])[0].lineColor;
    return of(result);
  }
}
